
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"i-edit_2"},[_c('path',{staticClass:"i-pencil",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"m9.892 5.108-7.267 7.267L1.5 16.5l4.125-1.125L12.75 8.25m0-6a2.121 2.121 0 1 1 3 3l-1.077 1.077L11.81 3.19z"}})])])
          )
        }
      }
    